export const partnerType = {
  PRIVATE: 'PRIVATE',
  BUSINESS: 'BUSINESS',
  ENTREPRENEUR: 'ENTREPRENEUR',
  OTHER: 'OTHER',
}
